<h2>History<button class="icon--history btn--default" type="button" (click)="toggleHistory()">Show History</button></h2>
<p-table [value]="medicalExamCertificateHistory" [columns]="cols" *ngIf="showHistory" dataKey="id">
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th class="w--arrow"></th>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field">{{col.header}}<p-sortIcon [field]="col.field"></p-sortIcon></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-expanded="expanded" let-data>
        <tr>
            <td>
                <a href="javascript:void(0)" [pRowToggler]="data">
                    <i [ngClass]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></i>
                </a>
            </td>
            <td *ngFor="let col of cols">
                <ng-container [ngSwitch]="col.header">
                    <ng-container *ngSwitchCase="'Restrictions'">
                        {{data.restrictionDisplayValues}}
                    </ng-container>
                    <ng-container *ngSwitchCase="'Jurisdiction'">
                        {{data.jurisdictionDisplayValue}}
                    </ng-container>
                    <ng-container *ngSwitchCase="'Decision'">
                        {{data.decisionDisplayValue}}
                    </ng-container>
                    <ng-container *ngSwitchCase="'Sign Date'">
                        {{data.medicalExamCertificateSignatureDate | shortDate}}
                    </ng-container>
                    <ng-container *ngSwitchCase="'Expiration Date'">
                        {{data.expirationDate | shortDate}}
                    </ng-container>
                    <ng-container *ngSwitchCase = "'Updated Date'">
                        {{data.updatedDate | shortDate}}
                    </ng-container>
                    <ng-container *ngSwitchDefault> 
                        {{data[col.field]}}
                    </ng-container>
                </ng-container>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="rowexpansion" let-data>
        <tr class="mvd_table__sub-container">
            <td colspan="10" class="subtable">
                <h2>Medical Examiner</h2>
                <ul class="list--definition__border">
                    <li><b>Name:</b> {{ data.medicalExaminerDisplayName }}</li>
                    <li><b>License Number:</b> {{ data.medicalExaminerLicenseNumber }}</li>
                    <li><b>Specialty Code:</b> {{ data.medicalExaminerSpecialtyCodeDisplayValue }}</li>
                    <li><b>Telephone Number:</b> {{ data.medicalExaminerPhoneNumber | phoneNumberUSA }}</li>
                </ul>
            </td>
        </tr>
        <tr>
            <td colspan="10" class="subtable">
                <ng-container *ngFor="let val of data.restrictionDetails">
                    <ul>
                        <li><b>{{val.restrictionDetailDisplayValue}}</b></li>
                        <li><b>Effective Date : </b>{{val.effectiveDateDisplayValue}}</li>
                        <li><b>Expiration Date : </b>{{val.expirationDateDisplayValue}}</li>
                    </ul>
                </ng-container>
            </td>
        </tr>
    </ng-template>
</p-table>